import { useMutation } from '@tanstack/react-query';
import { SubscriptionCancelRequest } from '@/types/request/SubscriptionCancelRequest';
import BackendClient from '@/api/backendClient.ts';
import { BackendSuccessResponse } from '@/types/response/Api/BackendSuccessResponse';
import { BackendErrorResponse } from '@/types/response/Api/BackendErrorResponse';
import { transformBackendErrors } from '@/utils/transformBackendErrors.ts';
import { queryClient } from '@/main.tsx';
import { User } from '@/models/User';

const useSubscriptionCancel = () => {
  const mutationFn = async (request: SubscriptionCancelRequest) => {
    return cancelSubscription(request);
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['user'] });
    },
  });
};

export default useSubscriptionCancel;

async function cancelSubscription(request: SubscriptionCancelRequest): Promise<void> {
  try {
    await BackendClient.post<BackendSuccessResponse<User>>('/api/stripe/cancel-subscription', request);

    return;
  } catch (error: any) {
    if (error.response && error.response.data) {
      const errorResponse = error.response.data as BackendErrorResponse;

      throw new Error(transformBackendErrors(errorResponse).join(', '));
    }

    throw new Error(error.message ?? 'An error occurred while canceling subscription.');
  }
}
